import { __exports as care } from './_virtual-care.js';
import { __require as requireContainer } from './vp-js-token-engine-build-infrastructure-container.js';
import { __require as requireCareTechClient } from './vp-js-token-engine-build-services-careTechClient.js';

var hasRequiredCare;

function requireCare () {
	if (hasRequiredCare) return care;
	hasRequiredCare = 1;

	Object.defineProperty(care, "__esModule", {
	  value: true
	});
	care.filter = filter;
	care.name = void 0;
	var _container = requireContainer();
	var _careTechClient = requireCareTechClient();
	care.name = 'care';
	async function filter(id) {
	  const culture = _container.contextService.getCulture(this);
	  const tenant = _container.contextService.getTenant(this);
	  if (!tenant) {
	    throw new Error('tenant not set');
	  }
	  if (!culture) {
	    throw new Error('culture not set');
	  }
	  try {
	    if (id === 'CONTACT_US_PAGE') {
	      const contactUsPage = await (0, _careTechClient.getContactUsPage)(culture, tenant);
	      return contactUsPage.new_platform_path;
	    } else {
	      const carePhoneData = await (0, _careTechClient.getCarePhoneData)(culture, tenant);
	      switch (id) {
	        case 'PHONE':
	          return carePhoneData.phoneNumber;
	        case 'PHONE_SCHEDULE':
	          return carePhoneData.shortFormatSchedule.length > 1 ? carePhoneData.shortFormatSchedule.join(', ') : carePhoneData.shortFormatSchedule.shift();
	        default:
	          return '';
	      }
	    }
	  } catch (e) {
	    return '';
	  }
	}
	
	return care;
}

export { requireCare as __require };
//# sourceMappingURL=vp-js-token-engine-build-filters-care.js.map
